import React, { useState } from "react";
import { Table, Row, Col, Button } from "antd";

import Confirmation from "../common/confirmation";
import SearchBar from "../common/SearchBar";
import SelectDropDown from "../common/SelectDropDown";

const RecipientList = props => {
  const {
    recipients,
    columns,
    rowSelection,
    state,
    onOpen,
    onClose,
    modalState,
    confirm,
    url,
    handleSearch
  } = props;

  const [dropdownValue, setDropdownValue] = useState();
  const groups = [...new Set(recipients && recipients.map(rec => rec.group))];
  groups.splice(0, 0, "All Groups");

  const setValue = value => {
    setDropdownValue(value);
  };

  const selectDropDownChange = () => {
    if (dropdownValue === "all groups" || dropdownValue === undefined) {
      return recipients;
    } else {
      return (
        recipients &&
        recipients.filter(content =>
          content.group.toLowerCase().includes(dropdownValue)
        )
      );
    }
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Confirmation
        title="Delete Recipient"
        modalState={modalState}
        confirm={confirm}
        onClose={onClose}
        message="Are you sure you want to delete recipient?"
      />
      <Row>
        <Col span={6} style={{ marginBottom: 20 }}>
          <SearchBar
            state={state}
            handleSearch={handleSearch}
            size="large"
            placeholder="Search by name or email..."
          />
        </Col>
        <Col span={6} style={{ marginLeft: 40, marginBottom: 20 }}>
          <SelectDropDown
            placeholder="Select Group"
            setValue={setValue}
            groups={groups}
            size="large"
          />
        </Col>
        <Col span={6}>
          <Row>
            <Col span={12}>
              <p style={{ marginTop: 10 }}>{state.selected_count} Selected</p>
            </Col>
            <Col span={12}>
              <p style={{ marginTop: 10, marginLeft: 10 }}>
                {recipients && recipients.length} Recipients
              </p>
            </Col>
          </Row>
        </Col>
        <Col span={4}>
          {url !== "/campaigns" ? (
            state.selected_count > 0 ? (
              <Button
                onClick={onOpen}
                type="link"
                style={{ marginTop: 10, float: "right" }}
              >
                Delete
              </Button>
            ) : null
          ) : null}
        </Col>
      </Row>
      <Col>
        <Table
          rowKey={record => record.id}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={selectDropDownChange()}
          pagination={{ pageSize: 25 }}
        />
      </Col>
    </div>
  );
};

export default RecipientList;
